var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gk-tag styled-tag"},[_vm._v(" "+_vm._s(_vm.label)+" "),(!_vm.cantRemove)?_c('GButton',{attrs:{"variant":"text","icon":"gk-x-icon"},on:{"click":function($event){return _vm.$emit('remove')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }